export const SEGMENT_TYPE = {
	ANTRAGS_DATEN: "ANTRAGS_DATEN",
	INITIALE_ATTACHMENTS: "INITIALE_ATTACHMENTS",
	HINZUGEFUEGTE_ATTACHMENTS: "HINZUGEFUEGTE_ATTACHMENTS",
	PROZESS_DATEN: "PROZESS_DATEN",
	GENERIERTE_DOKUMENTE: "GENERIERTE_DOKUMENTE"
} as const;

export const SEGMENT_LABELS: Record<string, string> = {
	[SEGMENT_TYPE.ANTRAGS_DATEN]: "Antragsdaten",
	[SEGMENT_TYPE.INITIALE_ATTACHMENTS]: "Initiale Anhänge",
	[SEGMENT_TYPE.HINZUGEFUEGTE_ATTACHMENTS]: "Hinzugefügte Anhänge",
	[SEGMENT_TYPE.PROZESS_DATEN]: "Prozessdaten",
	[SEGMENT_TYPE.GENERIERTE_DOKUMENTE]: "Generierte Dokumente"
} as const;

export const CONFIG_KEY = {
	INCLUDE_ALL_ATTACHMENTS: "INCLUDE_ALL_ATTACHMENTS",
	INITIAL_ATTACHMENTS_SELECTION: "INITIAL_ATTACHMENTS_SELECTION",
	SORTIERUNG: "SORTIERUNG",
	VERBUND_DATEI: "VERBUND_DATEI",
	ALLOW_CUSTOM_SEGMENT_SORTING: "ALLOW_CUSTOM_SORTING"
} as const;

export const INITIAL_ATTACHMENTS_SELECTION = {
	ALL: "ALL",
	PRESELECTED: "PRESELECTED",
	UNSELECTED: "UNSELECTED"
} as const;

export const ATTACHMENT_TYPE = {
	INITIAL: "INITIAL",
	GENERIERT: "GENERIERT",
	ATTACHMENT: "ATTACHMENT"
} as const;

export const EXTERNAL_ENUM_CACHE_KEY = {
	ARCHIVE_ATTACHMENT_OPTIONS: "archive_attachment_options",
	ARCHIVE_INITIAL_ATTACHMENT_OPTIONS: "archive_initial_attachment_options",
	ARCHIVE_PAPIERFORM_OPTIONS: "archive_papierform_options",
	ARCHIVE_DOKART_OPTIONS: "archive_dokart_options",
	ARCHIVE_SENDER_OPTIONS: "ARCHIVE_SENDER"
} as const;

export const PAPIERFORM = {
	NEIN: "001",
	JA: "002"
} as const;

export const ELEMENT_NAME = {
	ROOT: "root",
	INITIAL_ANGEHAENGT: "initialAngehaengt"
} as const;

export const PATH = {
	ROOT_ANTRAG: "/root/antrag/"
} as const;

export const ANNOTATION = {
	MF_RUNTIME_EXTERNAL_ENUMERATION: "mf_runtime_externalEnumeration",
	GENERIERTES_DOKUMENT: "generiertesDokument"
} as const;

export const STRING_VALUE = {
	TRUE: "true"
} as const;
